import publicUrl from './publicUrl';



export default publicUrl(({ roleId = ':roleId' }) => `/administration/roles/${roleId}/edit`);
